// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3sgg6","header":"ReportDetails_header__3ePB8","title":"ReportDetails_title__ODheN","left":"ReportDetails_left__yrZpn"};